<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-4">
          <fieldset style="height: 83.5vh">
            <legend class="text-black">
              {{ $t('studentScoringEntry.scoreEntry') }}
            </legend>
            <div
              class="overflow-auto"
              style="max-height: 80vh"
              v-if="isNotIgnoreByScoringCycle"
            >
              <table>
                <thead>
                  <tr>
                    <th class="ts-text-xs">
                      {{ $t('studentScoringEntry.component') }}
                    </th>
                    <th class="ts-text-xs text-right">
                      {{ $t('studentScoringEntry.grading') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in dataInput.sc_subject_id_list"
                    :key="index"
                  >
                    <td>
                      <span class="badge badge-primary ts-text-xs">{{
                        getComponentName(item.sc_subject_id)
                      }}</span>
                    </td>
                    <td style="width: 180px">
                      <select class="form-control bb" v-model="item.grade">
                        <option value="">{{ $t('select') }}</option>
                        <option
                          v-for="(grading, index) in gradingDefiniton"
                          :key="index"
                          :value="grading.grade"
                        >
                          {{ grading.grade }}
                        </option>
                      </select>
                      <div
                        class="validate ts-text-xs"
                        v-if="
                          errors.has('sc_subject_id_list.' + index + '.grade')
                        "
                      >
                        {{
                          errors.first('sc_subject_id_list.' + index + '.grade')
                        }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              v-if="!isNotIgnoreByScoringCycle"
              class="text-center ts-justify-items-center"
            >
              Ignore entry score for scoring cycle:
              <span class="ts-font-bold text-primary">
                {{
                  scoringCycleSelected
                    ? scoringCycleSelected.scoring_cycle_name
                    : '-'
                }}
              </span>
            </div>
          </fieldset>
        </div>
        <div class="col-md-8 ts-space-y-2">
          <div class="row">
            <div class="col-md-8 ts-space-y-2">
              <student-info-entry
                v-model="model"
                :class-operations="classOperations"
                :student-profiles="studentProfiles"
              />
              <grading-definition
                v-model="model"
                :grading-definitions="gradingDefinitions"
              />
            </div>
            <div class="col-md-4">
              <div class="col-md-12">
                <div id="cover-image">
                  <img
                    :src="require('@/assets/background-student-profile.png')"
                    alt
                    class="cover"
                  />
                  <div id="img-frame" class="text-center mb-1">
                    <img
                      v-lazy="{
                        src: studentProfiles.photo,
                        error: require('@/assets/user_default.png'),
                        loading: require('@/assets/Rolling-1s-200px_2.svg')
                      }"
                    />
                  </div>
                </div>
                <div class="row form-group m-b-15">
                  <div class="col-md-12 text-center">
                    <span>{{
                      studentProfiles ? studentProfiles.card_number : '-'
                    }}</span>
                    <h3
                      class="
                        text-center
                        ts-font-bold ts-text-lg
                        mt-2
                        mb-0
                        text-uppercase text-primary
                      "
                    >
                      {{ studentProfiles ? studentProfiles.full_name_en : '-' }}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <fieldset style="height: 45vh">
              <legend class="text-black">
                {{ $t('studentScoringEntry.scoreRating') }}
              </legend>
              <learning-strands-rating
                v-model="dataInput.learning_strands_sc_subject_id_list"
                :model-data="model"
                :elective-subjects="electiveSubjects"
                v-if="enableRating"
              />
              <div
                v-if="!enableRating"
                class="text-center ts-justify-items-center"
              >
                No enable rating score entry for scoring cycle:
                <span class="ts-font-bold text-primary">
                  {{
                    scoringCycleSelected
                      ? scoringCycleSelected.scoring_cycle_name
                      : '-'
                  }}
                </span>
              </div>
            </fieldset>
          </div>
        </div>
        <a-modal
          v-if="advisor_comment"
          v-model="advisor_comment"
          :zIndex="1020"
          :title="'Student Name : ' + studentProfiles.full_name_en"
          :maskClosable="false"
          width="950px"
          :footer="null"
        >
          <advisor-comment
            v-model="model"
            @closeModal="() => (advisor_comment = false)"
          />
        </a-modal>
      </div>
    </ts-loading-banner>
    <div class="ant-modal-footer ts-bottom-0 ts-left-0 ts-fixed ts-w-full">
      <ts-button @click.prevent="onAdvisorComment()">{{
        $t('studentScoringEntry.comment')
      }}</ts-button>
      <ts-button @click.prevent="$emit('closeModal')">{{
        $t('cancel')
      }}</ts-button>
      <ts-button
        color="primary"
        @click.prevent="onSave"
        :waiting="waiting"
        :disabled="waiting"
        >{{ $t('save') }}</ts-button
      >
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import LearningStrandsRating from './learning-strands-rating'
import StudentInfoEntry from './student-info-entry'
import AdvisorComment from './advisor-comment.vue'
import GradingDefinition from './grading-definition.vue'

export default {
  name: 'studentScoringEntryGrading',
  props: [
    'value',
    'paramsGetComponent',
    'classOperations',
    'studentProfiles',
    'ignoreScoringOnCycle',
    'enableRatingOnCycle'
  ],
  components: {
    LearningStrandsRating,
    StudentInfoEntry,
    AdvisorComment,
    GradingDefinition
  },
  data () {
    return {
      waiting: false,
      loading: false,
      show_alert: false,
      advisor_comment: false,
      errors: new Errors(),
      scoreComponents: [],
      electiveSubjects: [],
      gradingDefinitions: [],
      model: {},
      dataInput: Object.assign({}, this.value, {
        sc_subject_id_list: [],
        learning_strands_sc_subject_id_list: []
      }),
      gradingDefiniton: []
    }
  },
  computed: {
    isNotIgnoreByScoringCycle () {
      return this.ignoreScoringOnCycle.length > 0
        ? !this.ignoreScoringOnCycle.includes(this.model.scoring_cycle_id)
        : true
    },
    enableRating () {
      return this.enableRatingOnCycle.length > 0
        ? this.enableRatingOnCycle.includes(this.model.scoring_cycle_id)
        : false
    },
    scoringCycleSelected () {
      return this.$store.state.studentScoringEntry.scoring_cycles.find(
        c => c.scoring_cycle_id == this.model.scoring_cycle_id
      )
    }
  },
  created () {
    this.model = this.value
    this.fetchData()
  },
  methods: {
    ...mapActions('studentScoringEntry', [
      'getProgramStructure',
      'getGradingComponent',
      'store',
      'findScoring'
    ]),
    onAdvisorComment () {
      this.advisor_comment = true
    },
    findScoringInput () {
      let {
        sc_item_subject_comp_list,
        sc_subject_id,
        st_class_id,
        ...params
      } = this.model
      return this.findScoring(params)
    },
    async fetchData () {
      this.loading = true
      let structure = await this.getProgramStructure({ ...this.model }).catch(
        error => {
          this.$toasted.error(error.message)
        }
      )

      await this.$store.dispatch('gradingDefinition/fetch', {
          filter: {
            acp_id: this.model.acp_id,
            acps_id: this.model.acps_id,
            score_version_id: this.paramsGetComponent.score_version_id
          },
          page: -1
        })
        .then(response => {
          this.gradingDefinitions = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })

      await this.getGradingComponent({
        // get component by grade setup wheather item base or subject
        ...this.paramsGetComponent
      })
        .then(response => {
          this.scoreComponents = response.data
          this.electiveSubjects = response.electiveSubjects
          this.createInputData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.getGradingDefiniton()
        .then(response => {
          this.gradingDefiniton = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
      await this.findScoringInput()
        .then(response => {
          if (!_.isEmpty(response.data) || response.data.length > 0) {
            this.dataInput.sc_subject_id_list = response.data
          }
          if (
            !_.isEmpty(response.learningStrands) ||
            response.learningStrands.length > 0
          ) {
            this.dataInput.learning_strands_sc_subject_id_list =
              response.learningStrands
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    createInputData () {
      let {
        sc_item_subject_comp_list,
        sc_subject_id,
        st_class_id,
        ...excludeData
      } = this.model
      this.dataInput = Object.assign({}, excludeData, {
        sc_subject_id_list: this.isNotIgnoreByScoringCycle
          ? this.scoreComponents.map(el => ({
              scoring_id: 0,
              sc_subject_id: el.id,
              grade: ''
            }))
          : [],
        learning_strands_sc_subject_id_list: this.enableRating
          ? this.electiveSubjects.map(el => ({
              scoring_id: 0,
              sc_subject_id: el.subject_id,
              grade: null
            }))
          : [] //enable learning strands rating in grade
      })
    },
    getComponentName (sc_subject_id) {
      return this.scoreComponents
        .filter(c => c.id == sc_subject_id)
        .reduce((init, item) => (init = item.name), null)
    },
    getGradingDefiniton () {
      return this.$store.dispatch('gradingDefinition/fetch', {
        fields: {
          score_grading_definitions: 'grade,definition_name_en'
        },
        filter: {
          acp_id: this.value.acp_id,
          score_version_id: this.paramsGetComponent.score_version_id,
          definition_type: 'Grading'
        },
        page: -1
      })
    },
    onSave () {
      this.waiting = true
      this.store(this.dataInput)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('closeModal')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>

<style lang="css" scoped>
table {
  width: 100%;
}
table > thead {
  border-bottom: 1px solid #d8d8d8;
  padding: 3px;
}
table > thead > tr > th {
  padding: 4px 7px;
}
table > tbody > tr > td {
  padding: 4px 7px;
}
.bb {
  border-bottom: 1px solid #d8d8d8;
  outline: none;
}
.cover {
  opacity: 0.2;
}
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.list-group-item {
  border: none !important;
  padding: 5px 0 5px 0;
  margin: 0;
  border-top: 1px solid #eee !important;
}
.list-group-item.address {
  border: none !important;
  padding-top: 2px;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin: -51%;
}
#img-frame img {
  object-fit: contain;
  width: 15%;
  height: 15%;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
